import { render, staticRenderFns } from "./PointBankAnotherlaneComplete.vue?vue&type=template&id=5e3ed76f"
import script from "./PointBankAnotherlaneComplete.vue?vue&type=script&lang=js"
export * from "./PointBankAnotherlaneComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports